import { type InsuranceCorporateIdentity } from "../types";

export function PronovaLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M285.761 64.2112C274.967 62.4895 265.706 71.5683 265.706 82.9626V302.427C265.706 313.761 274.967 322.84 285.761 321.119C347.88 311.215 394.41 257.723 394.41 192.671C394.41 127.618 347.88 74.119 285.761 64.21V64.2112Z"
        fill="#FF876E"
      />
      <path
        d="M137 256.661C137 221.17 165.904 192.668 201.353 192.668C235.439 192.668 265.706 221.169 265.706 256.914V386.263C265.706 421.317 235.438 450 201.353 450C165.905 450 137 421.317 137 386.007V256.661Z"
        fill="#FFF500"
      />
      <path
        d="M201.353 192.665C236.894 192.665 265.706 163.862 265.706 128.332C265.706 92.8025 236.894 64 201.353 64C165.812 64 137 92.8025 137 128.332C137 163.862 165.812 192.665 201.353 192.665Z"
        fill="white"
      />
    </svg>
  );
}

export const Pronova: InsuranceCorporateIdentity = {
  id: "pronova",
  name: "pronova BKK",
  logo: PronovaLogo,
  backgroundColor: "#002D73",
  textColor: "#FFFFFF",
  wildcard: "pronova bkk",
  type: "statutory",
};
